import React, { useEffect, useRef, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { useLanguage } from "../../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard6,
  reset_current_total_bar6,
  reset_current_total_line6,
  reset_current_vs_actual_budget_bar6,
  reset_current_vs_actual_budget_line6,
  reset_expense_bar_chart,
  reset_expense_bar_chart6,
  reset_expense_line_chart,
  reset_expense_line_chart6,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph6,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph6,
  reset_kanban_data,
  reset_kanban_data6,
  reset_open_acc_receive,
  reset_open_acc_receive6,
  reset_profit_line_chart,
  reset_profit_line_chart6,
  reset_sales_line_chart,
  reset_sales_line_chart6,
  reset_task_at_risk6,
  reset_task_complete_status6,
  reset_task_deviation_analysis6,
  reset_tax_line6,
  reset_tax_pie6,
  reset_transaction_dashboard6,
  set_balance_dashboard6,
  set_current_total_bar6,
  set_current_total_line6,
  set_current_vs_actual_budget_bar6,
  set_current_vs_actual_budget_line6,
  set_expense_bar_chart,
  set_expense_bar_chart6,
  set_expense_line_chart,
  set_expense_line_chart6,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph6,
  set_expense_per_line_graph,
  set_expense_per_line_graph6,
  set_open_acc_receive,
  set_open_acc_receive6,
  set_profit_line_chart,
  set_profit_line_chart6,
  set_sales_line_chart,
  set_sales_line_chart6,
  set_task_at_risk6,
  set_task_complete_status6,
  set_task_deviation_analysis6,
  set_tax_line6,
  set_tax_pie6,
  set_transaction_dashboard6,
  toggle_Kanban_data,
  toggle_Kanban_data6,
} from "../../../../redux/reducers/favDashboardSlice";
import HttpClient from "../../../../utils/HttpClient";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import DashboardManager6 from "../../dashboard/DashboardManager6";
import RiskManagement from "../../../TaskManager/RiskManagement";
import "./CurrentMonthChart.css";
import Loader from "../../../../Loader/Loader";
import RiskManagement6 from "../../../TaskManager/RiskManagement6";
import { useSelector } from "react-redux";

const data = [
  {
    name: "Revenue",
    revenue: 10000,
    revenueBudget: 273000,
    expense: 0,
    expenseBudget: 104000,
  },
];

const CurrentMonthChart = () => {
  const { taskCompletionStatus6, taskAtRisk6, taskDeviationAnalysis6 } =
    useSelector((state) => state?.favDashboard);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();
  const [widgetsSix, setwidgetsSix] = useState([]);
  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  const componentRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const fetchWidgetOneData = async () => {
    try {
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setwidgetsSix(res?.widgets?.six || []);
      } else {
        console.log("error", res);
        setwidgetsSix([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  useEffect(() => {
    if (widgetsSix) {
      setSelectedWidgetOne(widgetsSix?.find((item) => item?.visible) || null);
    }
  }, [widgetsSix]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
    setTimeout(() => {
      scrollToComponent();
    }, 100);
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data6());
      dispatch(reset_open_acc_receive6());
      dispatch(reset_expense_per_line_graph6());
      dispatch(reset_expense_per_bar_graph6());
      dispatch(reset_expense_bar_chart6());
      dispatch(reset_expense_line_chart6());
      dispatch(reset_profit_line_chart6());
      dispatch(reset_sales_line_chart6());
      dispatch(reset_task_complete_status6());
      dispatch(reset_task_deviation_analysis6());
      dispatch(reset_task_at_risk6());
      dispatch(reset_current_total_bar6());
      dispatch(reset_current_total_line6());
      dispatch(reset_current_vs_actual_budget_bar6());
      dispatch(reset_current_vs_actual_budget_line6());
      dispatch(reset_transaction_dashboard6());
      dispatch(reset_balance_dashboard6());
      dispatch(reset_tax_line6());
      dispatch(reset_tax_pie6());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data6());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive6());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph6());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph6());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart6());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart6());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart6());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart6());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status6());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis6());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk6());
          break;
        case "current total (bar graph)":
          dispatch(set_current_total_bar6());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line6());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar6());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line6());
          break;

        case "Balance dashboard":
          dispatch(set_balance_dashboard6());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard6());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie6());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line6());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleAddWidget = async (widget) => {
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        setSelectedWidgetOne(widget);
        closeModal();
        fetchWidgetOneData();
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  return (
    <>
      <div className="chart-wrapper-mc" ref={componentRef}>
        {!selectedWidgetOne && (
          <Loader />
          // <div></div>
        )}
        <div className="chart-header-mc">
          <h3 className="chart-title-mc">
            {selectedWidgetOne?.name?.toUpperCase() ||
              "CURRENT MONTH, ACTUAL vs BUDGET"?.toUpperCase()}
          </h3>

          <div className="icons-dc">
            <i
              className="fa-regular fa-pen-to-square icon-dc"
              onClick={openModal}
            ></i>
            {/* <i className="fa-solid fa-trash icon-dc"></i> */}
          </div>
        </div>

        <div className="chart-legend-mc">
          <span className="legend-item-mc">
            <span className="legend-dot-mc rev-mc"></span> Revenue
          </span>
          <span className="legend-item-mc">
            <span className="legend-dot-mc revb-mc"></span> Revenue budget
          </span>
          <span className="legend-item-mc">
            <span className="legend-dot-mc exp-mc"></span> Expense
          </span>
          <span className="legend-item-mc">
            <span className="legend-dot-mc expb-mc"></span> Expense budget
          </span>
        </div>

        {/* Render the widget based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager6 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement6
            taskCompleteStatus={taskCompletionStatus6}
            taskAtRisk={taskAtRisk6}
            taskDeviationAnalysis={taskDeviationAnalysis6}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement6
            taskCompleteStatus={taskCompletionStatus6}
            taskAtRisk={taskAtRisk6}
            taskDeviationAnalysis={taskDeviationAnalysis6}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement6
            taskCompleteStatus={taskCompletionStatus6}
            taskAtRisk={taskAtRisk6}
            taskDeviationAnalysis={taskDeviationAnalysis6}
          />
        )}

        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager6 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager6 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager6 />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase() ||
                "Select Widget"?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsSix?.length > 0 ? (
                widgetsSix.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CurrentMonthChart;
